import React, { Component } from "react";
import { Row, Col, Alert, InputGroup, InputGroupText } from "reactstrap";

import { FetchData } from "../utils/DataFetch";
import { GetCookie } from "../utils/Common";
import {
  RptMarketReportSummaryTableDefault,
  columns as rptMarketReportSummaryColumns,
} from "./RptMarketReportSummaryTableDefault";
import { exportRowsToExcel } from "../utils/ReportExport";
import { ExcelExportButton } from "./ExcelExportButton";

export class RptMarketReportSummary extends Component {
  static displayName = RptMarketReportSummary.name;

  constructor(props) {
    super(props);
    this.state = {
      rptMarketReportSummaryList: [],
      loading: false,
      fetchingData: false,
      alert: {
        color: "info",
        message: "",
        isOpen: false,
      },
      searchModel: {
        ClientAbbrv: "",
        StartDate: "",
        EndDate: "",
      },
    };
    this.user = JSON.parse(GetCookie("user"));

    this.renderRptMarketReportSummary =
      this.renderRptMarketReportSummary.bind(this);
    //
    this.handleSearchChange = this.handleSearchChange.bind(this);
    //
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.exportMarketReportSummary =
      this.exportMarketReportSummary.bind(this);
    //
  }

  componentDidMount() {}

  handleSearchChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateMarketReportSummaryData();
    }
  }

  async populateMarketReportSummaryData() {
    this.setState({ fetchingData: true });

    FetchData(
      "/getrptmarketreportsummary",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({
        rptMarketReportSummaryList: data,
        loading: false,
        fetchingData: false,
      });
    });
  }

  exportMarketReportSummary() {
    exportRowsToExcel({
      rows: this.state.rptMarketReportSummaryList,
      columns: rptMarketReportSummaryColumns,
      fileName: "MarketReportSummary.xlsx",
    });
  }

  renderRptMarketReportSummary(rptMarketReportSummaryList) {
    return (
      <RptMarketReportSummaryTableDefault
        rptMarketReportSummary={rptMarketReportSummaryList}
      ></RptMarketReportSummaryTableDefault>
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderRptMarketReportSummary(this.state.rptMarketReportSummaryList)
    );

    return (
      <div>
        <center>
          <Alert
            color={this.state.alert.color}
            isOpen={this.state.alert.isOpen}
          >
            {this.state.alert.message}
          </Alert>
        </center>
        <h5 id="tabelLabel">Market Report Summary</h5>
        <Row className="align-items-center g-2">
          <Col className="col-4">
            <InputGroup size="sm">
              <input
                name="JobTotal"
                ref={(input) => {
                  this.JobTotal = input;
                }}
                type="text"
                className="form-control form-control-text"
                value={this.state.searchModel.JobTotal}
                onChange={this.handleSearchChange}
                onFocus={this.handleSearchFocus}
                placeholder="Job Total"
                onKeyDown={this.handleKeyDown}
              />
            </InputGroup>
          </Col>
          <Col className="col-auto">
            <InputGroup size="sm">
              <ExcelExportButton
                onClick={this.exportMarketReportSummary}
                title="Export Market Report Summary"
              />
            </InputGroup>
          </Col>
        </Row>
        <hr />

        <div>{contents}</div>
      </div>
    );
  }
}
